module.exports = __webpack_public_path__ + "Simple-Line-Icons.dacd16c9a3d2cb61b472.eot";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot
// module id = ../../../../../theme/scss/icons/simple-line-icons/fonts/Simple-Line-Icons.eot
// module chunks = styles